export default import.meta.ROLLDOWN_FILE_URL_g6npiV2vV6kDx7palhTZNA